import React, { useState } from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PageMembershipMatchingAttributesBlockProps } from '../PageMembershipMatchingAttributesBlock';
import { PageMembershipMatchingAttributesEditView } from '../views/PageMembershipMatchingAttributesEditView';
import { PageMembershipMatchingAttributesDefaultView } from '../views/PageMembershipMatchingAttributesDefaultView';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export function PageMembershipMatchingAttributesInteractions({
  views,
  activeView,
}: PageMembershipMatchingAttributesBlockProps) {
  const { t } = useSonTranslation('PageMembershipMatchingAttributes');
  const { refresh } = useRefreshBlock();
  const [currentActiveView, setCurrentActiveView] = useState(activeView);
  const id = useHtmlValidId();

  return (
    <>
      {views.edit ? (
        <BlockBar heading={t('edit.titleText')} hierarchy={3} helpText={t('helpText')}>
          <BlockBarButton
            text={t('edit.titleText')}
            svgSpriteId={currentActiveView === 'default' ? Icons.EDIT_PENCIL : Icons.DECLINE_CROSS}
            aria-controls={id}
            onClick={() => {
              if (currentActiveView === 'default') {
                setCurrentActiveView('edit');
              } else {
                setCurrentActiveView('default');
                refresh();
              }
            }}
          />
        </BlockBar>
      ) : null}
      <div id={id}>
        {currentActiveView === 'edit' && views.edit ? (
          <PageMembershipMatchingAttributesEditView {...views.edit} />
        ) : null}
        {currentActiveView === 'default' && views.default ? (
          <PageMembershipMatchingAttributesDefaultView {...views.default} />
        ) : null}
      </div>
    </>
  );
}
